export default {"src":"/_next/static/media/whatsapp-icon.397ffbef.svg","height":16,"width":16};